import { render, staticRenderFns } from "./TCard.vue?vue&type=template&id=5847f20b&scoped=true&"
import script from "./TCard.vue?vue&type=script&lang=js&"
export * from "./TCard.vue?vue&type=script&lang=js&"
import style0 from "./TCard.vue?vue&type=style&index=0&id=5847f20b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5847f20b",
  null
  
)

/* custom blocks */
import block0 from "./TCard.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports